import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getCustomGeoZonesCategories: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].GET_CUSTOM_GEO_ZONES_CATEGORIES,
	},
	getCustomGeoZonesCategory: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].GET_CUSTOM_GEO_ZONES_CATEGORY,
	},
	createCustomGeoZonesCategory: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].CREATE_CUSTOM_GEO_ZONES_CATEGORY,
	},
	putCustomGeoZonesCategory: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].PUT_CUSTOM_GEO_ZONES_CATEGORY,
	},
	patchCustomGeoZonesCategory: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].PATCH_CUSTOM_GEO_ZONES_CATEGORY,
	},
	deleteCustomGeoZonesCategory: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES].DELETE_CUSTOM_GEO_ZONES_CATEGORY,
	},
}
